import styled from "styled-components";
import { ColorKey } from "@template/theme/types/color.type.ts";

export const IconHolderWrapper = styled.div<{ $color: ColorKey }>`
  display: flex;
  width: 64px;
  height: 64px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 62px;
  background-color: ${({ theme, $color }) => theme.colors[$color][100]};
  color: ${({ theme, $color }) => theme.colors[$color][900]};
  flex-shrink: 0;

  & svg {
    width: 36px;
    height: 36px;
  }
`;
